enum EventLocation {
  Body = 'body',
  Footer = 'footer',
  Header = 'header',
  Overlay = 'overlay'
}

export default EventLocation;
